module.exports = __webpack_public_path__ + "static/media/college_7.4a88e1a3.jpg";